import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { initAnalytics, captureUtm, getUtm, track } from "../lib/analytics";
import { packTotal } from "../lib/format";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [selectedPackId, setSelectedPackId] = useState(() => localStorage.getItem("pc_pack"));
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => {
    captureUtm();
    api.get("/config/public").then((r) => {
      setConfig(r.data);
      initAnalytics(r.data);
    }).catch(() => {});
  }, []);

  const selectedPack = useMemo(() => {
    if (!config) return null;
    return config.packs.find((p) => p.id === (selectedPackId || config.default_pack)) || config.packs[0];
  }, [config, selectedPackId]);

  const selectPack = (id) => {
    setSelectedPackId(id);
    localStorage.setItem("pc_pack", id);
  };

  const openCart = (packId) => {
    if (packId) selectPack(packId);
    const pack = packId ? config?.packs.find((p) => p.id === packId) : selectedPack;
    if (pack) {
      track("AddToCart", {
        value: packTotal(pack),
        currency: "USD",
        content_ids: ["pelocero"],
        contents: [{ id: "pelocero", quantity: pack.units, price: Number(pack.price) }],
        num_items: pack.units,
      });
    }
    setCartOpen(true);
  };

  const checkout = async () => {
    if (!selectedPack) return;
    track("InitiateCheckout", {
      value: packTotal(selectedPack),
      currency: "USD",
      content_ids: ["pelocero"],
      contents: [{ id: "pelocero", quantity: selectedPack.units, price: Number(selectedPack.price) }],
      num_items: selectedPack.units,
    });
    const { data } = await api.post("/payments/checkout", {
      pack_id: selectedPack.id,
      origin_url: window.location.origin,
      utm: getUtm(),
    });
    window.location.href = data.checkout_url;
  };

  return (
    <StoreContext.Provider value={{ config, selectedPack, selectPack, cartOpen, setCartOpen, openCart, checkout }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
